import { Help as HelpIcon } from '@mui/icons-material';
import type { TooltipProps } from '@mui/material';
import {
  alpha,
  styled,
} from '@mui/material/styles';
import { tooltipClasses } from '@mui/material/Tooltip';
import Tooltip from '@mui/material/Tooltip';

export const InfoIcon = styled(HelpIcon)({
  '&&': { // to overwrite mui default styles? without this the icons are too big
    color: '#3196CC',
    width: 16,
    height: 16,
  },
});

export const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: theme.palette.background.paper,
    color: alpha(theme.palette.common.black, 0.87),
    maxWidth: 220,
    fontSize: 12,
    border: `1px solid ${theme.palette.grey[500]}`,
  },
}));
